/*jshint moz:true, eqnull:true, multistr: true */
/* eslint no-unused-expressions: "warn" */

//This represents tracking version currently in use;
const trackingVersion = "1";
const gaScriptHolder = (window.GoogleAnalyticsObject = "_ga");

const abTestingEventName = "AB test";

// Map of all custom dimensions we use
var dimensionsMap = {
  trackingVersion: "dimension6",
  clientId: "dimension7",
  windowId: "dimension8",
  hitId: "dimension9",
  hitTime: "dimension10",
  hitType: "dimension11",
  gaSessionId: "dimension12",
  wlSessionId: "dimension13",
  transId: "dimension14",
  siteSection: "dimension15",
  emailHash: "dimension16",
};

var analyticsCb = function (cb) {
  if (cb != null) {
    cb();
  }
  return;
};

/**
 * Google Analytics wrapper which manages dispatching GA calls across different objects and allows overriding default GA methods behaviour.
 *
 * @returns {Object} Loaded instance of __this
 */
export function _analyticsWrapper() {
  var __this = this;
  // Status of the object.
  // 0 - initilized
  // 1 - loaded
  // Note: we set it after first ga object has loaded
  __this.analyticsStatus = 0;
  __this.gaObjects = {};

  /**
   * Initializes Google Analytics object for given objectName
   *
   * @param {string} objectName Name of the object to initialize
   * @param {string} gaKey Google Analytics apikey
   * @param {Object} opts Set of options to use during initialization
   */
  __this.init = function (objectName, gaKey, opts, cb) {
    opts = opts || {};
    var mode = opts.mode || "auto";
    __this.gaObjects[objectName] = {
      status: 0,
      tracker: null,
      gaObject: null,
      getTrackerName: function () {
        return this.tracker.get("name") || "t0";
      },
    };
    if (gaKey === "") {
      // If for some reason we can't initialize the analytics client
      // just shim it with fake function
      // set it to dummy (kw)
      __this.gaObjects[objectName].tracker = -1;
    } else {
      // We don't want to load library multiple times
      if (__this.status !== 1) {
        (function (i, s, o, g, r, a, m) {
          i.GoogleAnalyticsObject = r;
          (i[r] =
            i[r] ||
            function () {
              (i[r].q = i[r].q || []).push(arguments);
            }),
            (i[r].l = 1 * new Date());
          (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
          a.async = 1;
          a.src = g;
          m.parentNode.insertBefore(a, m);
        })(
          window,
          document,
          "script",
          "//www.google-analytics.com/analytics.js",
          gaScriptHolder
        );
      }
    }

    __this.create(
      objectName,
      gaKey,
      opts.mode,
      opts.additionalParams,
      function (ok) {
        __this.gaObjects[objectName].status = ok ? 1 : -1;
      }
    );

    // Wait for tracker to initialize
    __this.getTrackerInfo(objectName, function (trackerInfo) {
      if (__this.__isDummy(objectName)) {
        return;
      }
      __this.gaObjects[objectName].tracker = trackerInfo;
      if (opts.setBeaconTransport) {
        __this.set(objectName, ["transport", "beacon"]);
      }

      // Overwrite original build task to include
      // additional fields - hit id, time and type
      var sourceBuildTask = trackerInfo.get("buildHitTask");
      var uuid = __this.__getUUID();
      trackerInfo.set("buildHitTask", function (model) {
        // Set hitId as a gaSession id - dimension which is has session
        // scope
        __this.setDimension(objectName, "gaSessionId", uuid);
        __this.setDimension(objectName, "hitTime", String(+new Date()));
        __this.setDimension(objectName, "hitType", model.get("hitType"));
        sourceBuildTask(model);
      });

      if (opts.setWlSessionId) {
        var trackingCookieVal =
          __this.getCookie(opts.trackingCookieName) || "NOTRKID";
        var trackingReqIdVal =
          __this.getCookie(opts.trackingRequestIdCookieName) || "NOTRKREQID";
        __this.setDimension(objectName, "wlSessionId", trackingCookieVal);
        // If we support tracking session using django cookies
        // we define hit id as <custom_seession_key>-<incremented request id for session>
        // which is always unique.
        __this.setDimension(
          objectName,
          "hitId",
          trackingCookieVal + "-" + trackingReqIdVal
        );
      } else {
        // Otherwise just use random value
        __this.setDimension(objectName, "hitId", uuid);
      }

      if (
        opts.setTransId &&
        window.baseDataLayer != null &&
        window.baseDataLayer.trans_id != null
      ) {
        __this.setDimension(
          objectName,
          "transId",
          window.baseDataLayer.trans_id
        );
      }

      if (opts.setClientId) {
        __this.setDimension(
          objectName,
          "clientId",
          trackerInfo.get("clientId")
        );
      }
      if (opts.useVersionDim) {
        __this.setDimension(objectName, "trackingVersion", trackingVersion);
      }
      if (opts.trackWindowId) {
        __this.setDimension(objectName, "windowId", __this.__getUUID());
      }

      if (window.aggroData.pageData) {
        __this.setDimension(
          objectName,
          "siteSection",
          window.aggroData.pageData.siteSection
        );
      }

      if (window.aggroData.confirmationData) {
        __this.setDimension(
          objectName,
          "emailHash",
          window.aggroData.confirmationData.customerEmailHash
        );
      }

      __this.pageview(objectName);
      // Send all ab test events which are defined on the page
      Object.keys(window.ABTestMap).map(function (k, v) {
        __this.sendEvent(objectName, [
          abTestingEventName,
          k + "_" + window.ABTestMap[k],
        ]);
      });
      __this.analyticsStatus = 1;
    });
  };

  /**
   * This dispatches the Google Analytics call based on arguments given, we assume that for native calls the syntax remains the same as using normal analytics functionality, but we also allow passing given object name and custom methods to call, if found we will perform wrapper call otherwise calling normal google analytics object.
   *
   * @param {array} args List of arguments to call
   */
  __this.__dispatch = function (args) {
    if (args.length < 1) {
      console.error("Invalid arguments passed to dispatch: ", args);
      return;
    }
    var objectName = args.shift();
    var dispatchAll = objectName === "all";
    var gaObjectNames = Object.keys(__this.gaObjects);

    if (!dispatchAll && gaObjectNames.indexOf(objectName) < 0) {
      // If no object name was passed just use all clients
      // put it back.
      args.unshift(objectName);
      dispatchAll = true;
    }
    var methodName = args.shift();
    var dispatchObjects = gaObjectNames.filter(function (dName) {
      if (dispatchAll) {
        return true;
      }
      return dName === objectName;
    });

    dispatchObjects.map(function (dName) {
      return __this.__call(dName, methodName, args);
    });
  };

  __this.__isDummy = function (objectName) {
    return __this.gaObjects[objectName].status === -1;
  };

  __this.__isLoaded = function (objectName) {
    return __this.gaObjects[objectName].status === 1;
  };

  /**
   * Retrieve tracker info for given GA object
   *
   * @param {string} objectName Name of the object
   * @param {function} cb Callback to perform when data has been loaded
   */
  __this.getTrackerInfo = function (objectName, cb) {
    if (__this.__isDummy(objectName)) {
      return cb(null);
    }
    window[gaScriptHolder](function () {
      var tracker = window[gaScriptHolder].getByName(objectName);
      if (tracker == null) {
        // keep retrying
        setTimeout(function () {
          return __this.getTrackerInfo(objectName, cb);
        }, 200);
      } else {
        return cb(tracker);
      }
    });
  };

  /**
   * Retrieve value for given cookie name
   *
   * @param {string} cookieName Name of the cookie
   * @returns {string || null} Value of the cookie
   */
  __this.getCookie = function (cookieName) {
    // Js doesn't have built in fn to retrieve cookie vals :*(kw)
    if (document.cookie.length > 0) {
      let cStart = document.cookie.indexOf(cookieName + "=");
      if (cStart != -1) {
        cStart = cStart + cookieName.length + 1;
        let cEnd = document.cookie.indexOf(";", cStart);
        if (cEnd == -1) {
          cEnd = document.cookie.length;
        }
        return unescape(document.cookie.substring(cStart, cEnd));
      }
    }
    return null;
  };

  /**
   * Generates unique uuid value to be used by Analytics module
   *
   * @returns {string} Generated random key
   */
  __this.__getUUID = function () {
    return "00000000-0000-4000-8000-000000000000".replace(/0/g, function () {
      return (0 | (Math.random() * 16)).toString(16);
    });
  };

  /**
   * Dispatch call to either a module built-in analytics method or native method if not found
   *
   * @param {string} objectName Name of the object to perform a call with
   * @param {string} methodName Method to call
   * @param {array} args Array of arguments to call with
   * @returns {Object} Result of Google Analytics call (if available)
   */
  __this.__call = function (objectName, methodName, args) {
    // If we don't overwrite default ga method, just call
    // it natively.
    // create copy of the args as they are passed by reference(kw)
    var argsToCall = args.slice();
    if (__this.__isDummy(objectName)) {
      return;
    }
    if (__this[methodName] == null) {
      methodName = objectName + "." + methodName;
      argsToCall.unshift(methodName);
      return __this.__curriedCall(argsToCall)();
    }
    var response;
    try {
      response = __this[methodName](objectName, argsToCall);
    } catch (e) {
      console.error(e);
      throw "Failed to call " + methodName + " on object: " + objectName;
    }
    return response;
  };

  /**
   * Applies arguments for Google Analytics call
   *
   * @param {string} analyticsObj Name of the analytics object
   * @param {array} params Array of arguments to call with
   * @returns {function} Curried function with preloaded set of arguments
   */
  __this.__curriedCall = function (params) {
    return function () {
      return window[gaScriptHolder].apply(window[gaScriptHolder], params);
    };
  };

  /**
   * Create analytics instance
   *
   * @param {string} analyticsObj Name of the object to call create with
   * @param {string} gaKey GA APIkey
   * @param {array} opts Array of args
   */
  __this.create = function (analyticsObj, gaKey, mode, additionalOpts, cb) {
    if (!gaKey) {
      return cb(false);
    }
    var opts = JSON.parse(JSON.stringify(additionalOpts));
    opts.name = analyticsObj;
    __this.__curriedCall(["create", gaKey, mode, opts])();
    return cb(true);
  };

  __this.send = function (analyticsObj, opts) {
    if (__this.__isDummy(analyticsObj)) {
      return;
    }
    var params = [analyticsObj + ".send"].concat(opts);
    return __this.__curriedCall(params)();
  };

  /**
   * Wrapper for native set fn
   *
   * @param {string} analyticsObj Name of analytics object
   * @param {array} opts Key and value to set
   */
  __this.set = function (analyticsObj, opts) {
    if (__this.__isDummy(analyticsObj)) {
      return;
    }
    var params = [analyticsObj + ".set"].concat(opts.slice(0, 2));
    return __this.__curriedCall(params)();
  };

  /**
   * Wrapper for native ga send event call
   *
   * @param {string} analyticsObj Name of analytics object
   * @param {object} opts Additional event options
   */
  __this.sendEvent = function (analyticsObj, opts) {
    var params = ["event"].concat(opts);
    return __this.send(analyticsObj, params);
  };

  /**
   * Send a page view to ga
   *
   * @param {string} analyticsObj Name of the analytics object
   */
  __this.pageview = function (analyticsObj) {
    return __this.send(analyticsObj, ["pageview"]);
  };

  /**
   * Set custom ga dimension
   *
   * @param {string} objectName Name of the object to call with
   * @param {string} Name of the dimension
   * @param {string} value Value of the dimension
   */
  __this.setDimension = function (objectName, dimName, value) {
    if (Object.keys(dimensionsMap).indexOf(dimName) < 0) {
      return;
    }
    __this.set(objectName, [dimensionsMap[dimName], value]);
  };
  return __this;
}

// Shim for old pages
window._analyticsWrapper = _analyticsWrapper;
